module.exports = "/_next/static/images/2674688d84d3505dba5f3c71e3ad449f-nucommunity-md@2x.jpg";